import React from 'react';
import moment from 'moment';

const AvailabilityModal = ({ isOpen, onClose, car }) => {
  if (!isOpen || !car) return null;

  const formatDate = (date) => moment(date).format('D MMM YYYY');

  const fullyBookedPeriods = car.fullyBookedPeriods || [];

  // Build available periods (gaps between booked periods)
  const today = moment().startOf('day');
  const availablePeriods = [];

  if (fullyBookedPeriods.length === 0) {
    availablePeriods.push({
      from: today.toDate(),
      to: null,
    });
  } else {
    const sortedBlocks = [...fullyBookedPeriods].sort(
      (a, b) => new Date(a.from) - new Date(b.from)
    );

    if (moment(sortedBlocks[0].from).isAfter(today)) {
      availablePeriods.push({
        from: today.toDate(),
        to: moment(sortedBlocks[0].from).subtract(1, 'day').toDate(),
      });
    }

    for (let i = 0; i < sortedBlocks.length - 1; i++) {
      const currentEnd = moment(sortedBlocks[i].to);
      const nextStart = moment(sortedBlocks[i + 1].from);
      if (nextStart.diff(currentEnd, 'days') > 1) {
        availablePeriods.push({
          from: currentEnd.add(1, 'day').toDate(),
          to: nextStart.subtract(1, 'day').toDate(),
        });
      }
    }

    const lastEnd = moment(sortedBlocks[sortedBlocks.length - 1].to);
    availablePeriods.push({
      from: lastEnd.add(1, 'day').toDate(),
      to: null,
    });
  }

  return (
    <div className="availability-modal-overlay" onClick={onClose}>
      <div className="availability-modal-content" onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="availability-modal-header">
          <div>
            <h3>{car.name || `${car.brand} ${car.model}`}</h3>
            <p>When this vehicle is available</p>
          </div>
          <button className="availability-modal-close" onClick={onClose}>×</button>
        </div>

        {/* Body */}
        <div className="availability-modal-body">
          {availablePeriods.length > 0 ? (
            <>
              <p className="availability-subtitle">
                This vehicle is currently booked for your selected dates. You can rent it during these periods:
              </p>

              <div className="availability-periods">
                {availablePeriods.map((period, idx) => (
                  <div key={idx} className="availability-period-card">
                    <div className="availability-period-icon">
                      <i className="fas fa-check-circle"></i>
                    </div>
                    <div className="availability-period-info">
                      <span className="availability-period-dates">
                        {period.to
                          ? `${formatDate(period.from)} — ${formatDate(period.to)}`
                          : `From ${formatDate(period.from)} onwards`
                        }
                      </span>
                      {period.to && (
                        <span className="availability-period-days">
                          {moment(period.to).diff(moment(period.from), 'days') + 1} days
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <p className="availability-empty">No availability information found.</p>
          )}
        </div>

        {/* Footer */}
        <div className="availability-modal-footer">
          <p className="availability-contact-text">Need help? Get in touch with us:</p>
          <div className="availability-contact-buttons">
            <a href="tel:+61893415334" className="availability-btn-call">
              <i className="fas fa-phone"></i> +61 893 415 334
            </a>
            <a href="mailto:info@tak8.com.au?subject=Vehicle Availability Enquiry" className="availability-btn-email">
              <i className="fas fa-envelope"></i> info@tak8.com.au
            </a>
          </div>
          <button className="availability-btn-close" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default AvailabilityModal;
